module.exports = __webpack_public_path__ + "static/media/Bettkissen_60x40_rueckseite.e30da5f3.png";